<template>
    <div class="faq instapaper_ignore">
        <div class="faq__header" @click="faqClicked">
            <h3 class="faq__title" :class="{ 'content-visible': showContent }">
                <slot name="title"></slot>
            </h3>
            <div class="faq__icon" :class="{ 'content-visible': showContent }"></div>
        </div>
        <transition name="faq-animation">
            <div v-show="showContent" class="faq__content">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            showContent: false,
            clicked: false,
        };
    },
    methods: {
        faqClicked() {
            this.showContent = !this.showContent;
            let title = this.$slots.title()[0].children.trim();

            if (title && !this.clicked) {
                window.ipse.dispatch({
                    action: 'button_clicked',
                    data_event: {
                        button: 'faq',
                        title: title,
                    },
                });
            }

            this.clicked = true;
        },
    },
};
</script>
